import type { ListItemButtonProps } from "@mui/material";
import { ListItemButton } from "@mui/material";
import useMergedSx from "../hooks/useMergedSx";

const itemSx = { py: 0.75, "&.Mui-selected": { color: "primary.main" } };

// Menu-style item for popovers and plain lists: MUI MenuItem throws when rendered outside Menu/MenuList.
const PopoverMenuItem = ({ sx, ...props }: ListItemButtonProps) => {
  const sxProps = useMergedSx(itemSx, sx);
  return <ListItemButton {...props} sx={sxProps} />;
};

export default PopoverMenuItem;
